var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"baseBtnPreStep",class:{'baseBtnNextStep--disabled': _vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"baseBtnPreStep__text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }